import { useEffect } from "react";
import { notification } from "antd";
import { UserInfo } from "@/entities/project";
import { useCoordinator } from "@/shared/lib/hooks";
import { UsersInfiniteScroll } from "../../../user-infinite-scroll";

interface IRepresentationFormEmail {
  onSuccess: (user: UserInfo) => void;
  error?: string;
  projectParticipantId?: any;
  clearTrigger?: number;
}

export const RepresentationFormEmail = ({
  error,
  onSuccess,
  projectParticipantId,
  clearTrigger,
}: IRepresentationFormEmail) => {
  const { projectId } = useCoordinator();

  useEffect(() => {
    if (error) {
      notification.error({
        message: "Неудачный запрос",
        description: error,
        placement: "topRight",
      });
    }
  }, [error]);

  const onUserSelectDev = (user: UserInfo) => {
    onSuccess(user);
  };

  return (
    <>
      <div className="email-input-container">
        <div className="email-input-label">
          <div className="email-input-title">Электронная почта</div>
          <UsersInfiniteScroll
            projectId={projectId}
            projectParticipantId={projectParticipantId}
            onUserSelect={onUserSelectDev}
            clearTrigger={clearTrigger}
          />
        </div>
      </div>
    </>
  );
};
